/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Me } from '../../models/me';
import { MeRequest } from '../../models/me-request';

export interface UpdateMe$Params {
      body: MeRequest
}

export function updateMe(http: HttpClient, rootUrl: string, params: UpdateMe$Params, context?: HttpContext): Observable<StrictHttpResponse<Me>> {
  const rb = new RequestBuilder(rootUrl, updateMe.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Me>;
    })
  );
}

updateMe.PATH = '/v0/users/me';
